export default __webpack_public_path__ + "static/media/mycv.5263b729.pdf";